export const INIT_MAP = 'INIT_MAP';
export const SET_BASEMAPS = 'SET_BASEMAPS';
export const GET_LAYERS = 'GET_LAYERS';
export const TOGGLE_BASEMAP = 'TOGGLE_BASEMAP';
export const TOGGLE_LAYER = 'TOGGLE_LAYER';
export const GET_OBJECT_DETAILS = 'GET_OBJECT_DETAILS';

